const ContactsPage = () => {
  return (
    <div className="container page-container contacts-page">
      <div className="page-kicker"><p className="eyebrow"><span /> будем на связи</p></div>
      <h1 className="page-title">Давайте начнём<br /><em>разговор.</em></h1>
      <div className="contacts-grid"><div className="contact-details">
          <div className="contact-block"><h2>Адрес</h2>
            <p>г. Калуга, ул. Кирова, д.20, офис 406</p>
          </div>
          <div className="contact-block"><h2>Телефоны</h2>
            <p>8-962-177-70-75</p>
          </div>
          <div className="contact-block"><h2>Email</h2>
            <p>Blagodatskaya-yu@mail.ru</p>
          </div>
        </div>
        <div className="map-frame">
          <iframe
            title="Яндекс карта"
            className="w-full h-full"
            src="https://yandex.ru/map-widget/v1/?um=constructor%3A&pt=36.2499,54.5149&z=17"
            allowFullScreen
          ></iframe>
        </div>
      </div>
    </div>
  );
};

export default ContactsPage;
